'use client';

import { Wizard } from '@/components/wizard/Wizard';

import { CreateJobTemplateFlow } from './CreateJobTemplateFlow';
import {
  defaultCreateJobTemplateWizardState,
  type CreateJobTemplateWizardState,
} from './createJobTemplateWizardState';

interface CreateJobTemplateWizardPanelProps {
  workspaceId: string;
  onAbort: () => void;
  onCreated: () => void;
}

export function CreateJobTemplateWizardPanel({
  workspaceId,
  onAbort,
  onCreated,
}: CreateJobTemplateWizardPanelProps) {
  return (
    <Wizard<CreateJobTemplateWizardState>
      onAbort={onAbort}
      hideBackArrow={true}
      onFinish={async () => {
        onCreated();
        return true;
      }}
      flow={[CreateJobTemplateFlow]}
      initialState={{ ...defaultCreateJobTemplateWizardState, workspaceId }}
      title='Create Job Template'
      stepperLabels={[]}
    />
  );
}
